import { createEntityAdapter } from "@reduxjs/toolkit";
import apiSlice from "../api/apiSlice";

const respAdapter = createEntityAdapter({});

const initialState = respAdapter.getInitialState({});

export const respApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRespByCommunityId: builder.query({
      query: (communityID) => ({
        url: `/communities/${communityID}/resp`,
        method: "GET",
      }),
      transformResponse: (responseData) => {
        if (responseData) {
          responseData = responseData.map((item) => ({ id: item.resp_id, ...item }));
          return respAdapter.setAll(initialState, responseData);
        }
        return respAdapter.setAll(initialState, []);
      },
      providesTags: [{ type: "RESP", id: "LIST" }],
    }),
    updateRespById: builder.mutation({
      query: ({ assetId, communityId, newAsset }) => ({
        url: `/communities/${communityId}/resp/${assetId}`,
        method: "PUT",
        body: {
          ...newAsset,
        },
      }),
      invalidatesTags: [{ type: "RESP", id: "LIST" }],
    }),
  }),
});

export const { useGetAllRespByCommunityIdQuery, useUpdateRespByIdMutation } = respApiSlice;
